import styled from 'styled-components';
import withAnimation from '@shared/components/utils/hoc/withAnimation';

const MenuContainer = styled.div<React.CSSProperties>``;

export default withAnimation(MenuContainer);
